import { render, staticRenderFns } from "./ContactsViewer.vue?vue&type=template&id=05b80978&scoped=true&lang=pug"
import script from "./ContactsViewer.vue?vue&type=script&lang=js"
export * from "./ContactsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b80978",
  null
  
)

export default component.exports